import React from "react";
import { Box, Typography } from "@mui/material";

const PAGE_BANNER_BG = "#1a245a";

const PageBanner = ({ title, children }) => (
  <Box
    sx={{
      py: { xs: 2, sm: 2.5, md: 3 },
      px: { xs: 2, sm: 3 },
      bgcolor: PAGE_BANNER_BG,
      textAlign: "center",
      color: "white",
    }}
  >
    <Typography
      variant="h4"
      fontWeight="bold"
      sx={{
        fontSize: { xs: "1.35rem", sm: "1.6rem", md: "2rem" },
        lineHeight: 1.25,
        wordBreak: "break-word",
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

export default PageBanner;
